import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import App from './App';
import {unregister} from './registerServiceWorker';
import history from "./history";
import connection from "./lib/connection";
import AppActions from './actions/AppActions';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <Router basename={baseUrl} history={history}>
    <App />
  </Router>,
  rootElement);

connection.start().catch((err) => {
    AppActions.updateState('connectionError', err.toString());
    return console.error(err.toString());
});

connection.on("Connected", () => {
    AppActions.updateState('connected', true);
});

unregister();
// registerServiceWorker();